module.exports = __webpack_public_path__ + "img/Weapon_09.a71df73c.png";